import { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import usePageMeta from '@/hooks/usePageMeta';
import { comics } from '@/mocks/comics';

const tabs = [
  { key: 'hot', label: '人气榜', icon: 'ri-fire-fill' },
  { key: 'rating', label: '高分榜', icon: 'ri-star-fill' },
  { key: 'update', label: '更新榜', icon: 'ri-refresh-line' },
  { key: 'finish', label: '完结榜', icon: 'ri-check-double-line' },
];

export default function Ranking() {
  usePageMeta({
    title: '排行榜',
    description: '漫画免费全集人气榜、高分榜、更新榜与完结榜，热门长篇与完结佳作多维度榜单，一次了解最值得看的漫画。',
    keywords: '漫画免费,漫画排行榜,人气榜,高分榜,漫画免费全集',
  });
  const [active, setActive] = useState('hot');

  const list = useMemo(() => {
    if (active === 'rating') return [...comics].sort((a, b) => b.rating - a.rating);
    if (active === 'update') return [...comics].sort((a, b) => a.year - b.year);
    if (active === 'finish') return comics.filter((c) => c.status === '已完结').sort((a, b) => Number(b.views.replace('亿', '').replace('万', '')) - Number(a.views.replace('亿', '').replace('万', '')));
    return [...comics].sort((a, b) => Number(b.views.replace('亿', '').replace('万', '')) - Number(a.views.replace('亿', '').replace('万', '')));
  }, [active]);

  return (
    <main>
      <section className="bg-background-100 py-10 md:py-14">
        <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
          <nav className="mb-2 text-sm text-foreground-500">
            <span>首页</span> <i className="ri-arrow-right-s-line" /> <span>排行榜</span>
          </nav>
          <h1 className="font-heading text-3xl text-foreground-950">漫画排行榜</h1>
          <p className="mt-2 text-sm text-foreground-600">漫画免费全集人气、高分、更新与完结多维度榜单，热门长篇与完结佳作一网打尽。</p>

          <div className="mt-6 inline-flex rounded-full border border-background-300 bg-background-50 p-1">
            {tabs.map((t) => (
              <button
                key={t.key}
                onClick={() => setActive(t.key)}
                className={`flex items-center gap-1.5 whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                  active === t.key ? 'bg-primary-500 text-background-50' : 'text-foreground-600 hover:text-primary-600'
                }`}
              >
                <i className={t.icon} /> {t.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-background-50 py-10 md:py-14">
        <div className="mx-auto w-full max-w-4xl px-4 md:px-6">
          <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
            {list.map((c, i) => (
              <Link
                key={c.id}
                to={`/comic/${c.id}`}
                className={`flex items-center gap-4 p-4 transition-colors hover:bg-background-100 ${i !== 0 ? 'border-t border-background-200/70' : ''}`}
              >
                <span className={`w-9 shrink-0 text-center font-heading text-2xl ${i < 3 ? 'text-primary-600' : 'text-foreground-300'}`}>
                  {i + 1}
                </span>
                <img src={c.cover} alt={`${c.title}排行封面`} className="h-20 w-14 shrink-0 rounded-md object-cover object-top" loading="lazy" />
                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-2">
                    <h3 className="truncate font-heading text-base text-foreground-950">{c.title}</h3>
                    <span className={`rounded-full px-2 py-0.5 text-[11px] ${c.status === '连载中' ? 'bg-accent-100 text-accent-800' : 'bg-secondary-100 text-secondary-800'}`}>
                      {c.status}
                    </span>
                  </div>
                  <p className="mt-1 truncate text-xs text-foreground-500">{c.category} · {c.author}</p>
                </div>
                <div className="shrink-0 text-right">
                  {active === 'rating' ? (
                    <span className="flex items-center justify-end gap-1 text-sm font-medium text-accent-600"><i className="ri-star-fill" />{c.rating.toFixed(1)}</span>
                  ) : (
                    <span className="text-sm font-medium text-foreground-700">{c.views}</span>
                  )}
                  <span className="mt-1 block text-[11px] text-foreground-400">{c.chapters.length} 话</span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}